module.exports = __webpack_public_path__ + "img/36_82.074ac0a6.png";